export const MODELS_CONFIG = {
  brand: {
    key: "brand",
    label: "Marca",
  },
  model: {
    key: "name",
    label: "Modelo",
  },
};

export const MODELS_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Modelos",
    },
  },
  modal: {
    titles: {
      edit: "Modificar Modelo",
      add: "Agregar Nuevo Modelo",
      delete: "¿Estas seguro de eliminar este Modelo?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      edit: "Editar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
  form: {
    dropdowns: {
      brand: "Seleccione una Marca",
    },
  },
};
